<template>
    <slot name="search-input" v-bind="this"></slot>
</template>

<script>
    export default {
        props: {
            actionUrl: {
                type: String,
                required: true
            },
            initialSearchQuery: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                searchQuery: this.initialSearchQuery,
            }
        },
        watch: {
            searchQuery(newVal, oldVal) {
                if(oldVal !== '' && newVal === '') {
                    this.submitForm();
                }
            }
        },
        methods: {
            triggerSearch() {
                this.submitForm();
            },
            submitForm() {
                this.$emit('wait', true);
                if(this.searchQuery) {
                    window.location.href = `${this.actionUrl}?search=${encodeURIComponent(this.searchQuery)}`;
                } else {
                    window.location.href = this.actionUrl;
                    this.$emit('wait', false)
                }
            }
        },
    }
</script>
